import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-complete-checkmark';
export var ID = 'icon-complete-checkmark';
/* eslint-disable max-len */

export var SVGCompleteCheckmark = function SVGCompleteCheckmark() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-260.000000, -90.000000)"
  }, React.createElement("g", {
    transform: "translate(102.000000, 64.000000)"
  }, React.createElement("polygon", {
    points: "161 34.5 162.5 33 164.5 35 169.5 30 171 31.5 164.5 38"
  })), React.createElement("g", {
    transform: "translate(100.000000, 64.000000)"
  }))));
};
/* eslint-disable max-len */

var CompleteCheckmark = function CompleteCheckmark(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGCompleteCheckmark
  });
};

CompleteCheckmark.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default CompleteCheckmark;